import {
  booleanAttribute,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'app-button-with-progress',
  templateUrl: './button-with-progress.component.html',
  styleUrls: ['./button-with-progress.component.sass'],
})
export class ButtonWithProgressComponent {
  @Input() loading$ = false;
  @Input({ transform: booleanAttribute }) isDisabled = false;
  @Input() label = 'Подтвердить';
  @Input() tooltip?: string | null = null;
  @Input() typeBtn = 'button';
  @Input() toggleShowBtn = true;
  @Input() matColor: ThemePalette = 'primary';
  @Output() clickHandler = new EventEmitter<boolean>();

  click() {
    this.clickHandler.emit();
  }
}
